import React from 'react';
import { Checkbox } from 'components/UI/Checkbox/Checkbox';

const CONSENT_LABEL = 'I agree to receive SMS updates and promotional messages.';
const CONSENT_HELPER_TEXT = 'Message and data rates may apply. Reply STOP to unsubscribe.';

type SmsMarketingConsentProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    className?: string;
    disabled?: boolean;
};

export const SmsMarketingConsent: React.FC<SmsMarketingConsentProps> = ({
    checked,
    onChange,
    className,
    disabled
}) => (
    <Checkbox
        className={className}
        checked={checked}
        disabled={disabled}
        onCheckedChange={onChange}
        label={CONSENT_LABEL}
        helperText={CONSENT_HELPER_TEXT}
    />
);
